<div class="l-top-navi">
  <div class="l-wrap l-wrap--sp-tb-full">
    <div class="l-wrap__inner">
      <div class="l-top-navi__inner l-top-navi__inner--has-progress">
        <div class="l-top-navi__back-area">
          <a
            id="pet-input-sub-header-back-link"
            (click)="clickReturnButton()"
            class="l-top-navi__back-link u-focus-cursor-pointer"
          >
            <span class="u-visually-hidden" [innerHTML]="'label.goBack' | staticMsg"></span>
          </a>
        </div>
        <!-- 画面タイトル -->
        <div class="l-top-navi__heading-area">
          <h1 class="l-top-navi__heading-text" [innerHTML]="'heading.petsReservation' | staticMsg"></h1>
        </div>
      </div>
    </div>
  </div>
</div>
